export default __webpack_public_path__ + "static/media/cow.2cd75c0b.jpg";